import React from 'react';
import moment from 'moment';
import i18n from 'i18next';

import { ReactComponent as Cross } from '../../picture/x-circle.svg';
import { ReactComponent as Check } from '../../picture/Check-circle.svg';

import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';

import ActionCard from '../jo-components/cards/actionCard/actionCard';
import { Box } from '../ui';
import { APIAction } from '../order-menu/api-action/api-action';
import BackContainer from '../resale/seller/components/backContainer';
import Header from '../resale/seller/components/header';
import Chip from '../resale/seller/components/chip';
import Message from '../resale/seller/components/message';
import './ticket-menu.css';

function TicketActions({ ticket, actions, onActionClick }) {
	const { t } = useTranslation();
	const locale = i18n.language;

	const translations = React.useMemo(() => {
		const defaultTranslations = {
			'DownloadTicketStep': t('widget.ticket.download'),
			'TicketUpdateFormStep': t('widget.ticket.edit'),
			'RefundStep': t('widget.ticket.refund'),
			'ResaleMenuStep': t('widget.ticket.manage_resale'),
			'TicketResaleStep': t('widget.ticket.manage_resale'),
			'RateChangeStep': t('widget.ticket.change-rate'),
			'CashlessRedirectStep': t('widget.ticket.cashless-redirect'),
		};
		let translationLabels = {};
		if (!actions) return translationLabels;
		translationLabels = defaultTranslations;
		actions.forEach(action => {
			//we only replace the translation if title is present and isn't a default value
			if (action.label && !action.label.includes('widget.action.'))
				translationLabels[action.type] = action.label;
		});
		return translationLabels;
	}, [actions]);

	const externalLinks = React.useMemo(()=>{
		let external_links_actions = actions.filter(action => action.type === 'External_link');
		if(!external_links_actions.length ){
			return;
		}

		return (
			<div>
				{external_links_actions.map((action)=><ActionCard 
					icon={action.config.icon || 'externalLink'}
					label={action.config.translations.hasOwnProperty(locale) ? action.config.translations[locale] : action.config.label }
					onClick={()=> window.open(action.config.url, '_blank')}
				/>) }
			</div>
		);
	}, [actions, locale])

	return (
		<>
			<APIAction name={'DownloadTicketStep'} actions={actions}>
				<ActionCard
					icon='download'
					label={translations['DownloadTicketStep']}
					onClick={() => {
						onActionClick('DownloadTicketStep', { attendee_id: ticket.id })
					}}
				/>
			</APIAction>

			<APIAction name={'TicketUpdateFormStep'} actions={actions}>
				<ActionCard
					icon='edit'
					label={translations['TicketUpdateFormStep']}
					onClick={() => onActionClick('TicketUpdateFormStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
				/>
			</APIAction>

			<APIAction name={'RateChangeStep'} actions={actions}>
				<ActionCard
					icon='refresh'
					label={translations['RateChangeStep']}
					onClick={() => onActionClick('RateChangeStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
					/>
			</APIAction>

			<APIAction name={'CashlessRedirectStep'} actions={actions}>
				<ActionCard
					icon='walletPay'
					label={translations['CashlessRedirectStep']}
					onClick={() => onActionClick('CashlessRedirectStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
					/>
			</APIAction>

			<APIAction name={'RefundStep'} actions={actions}>
				<ActionCard
					icon='rotate'
					label={translations['RefundStep']}
					onClick={() => onActionClick('RefundStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
				/>
			</APIAction>

			<APIAction name={'TicketResaleStep'} actions={actions}>
				<ActionCard
					icon='cart'
					label={translations['TicketResaleStep']}
					onClick={() => onActionClick('TicketResaleStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
					/>
			</APIAction>

			<APIAction name={'ResaleMenuStep'} actions={actions}>
				<ActionCard
					icon='cart'
					label={translations['ResaleMenuStep']}
					onClick={() => onActionClick('ResaleMenuStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
					/>
			</APIAction>

			<APIAction name={'ModerationFormUpdateStep'} actions={actions}>
				<ActionCard
					icon='edit'
					label={translations['ModerationFormUpdateStep']}
					onClick={() => onActionClick('ModerationFormUpdateStep', { attendee_id: ticket.id })}
					actions={actions}
					ticket={ticket}
				/>
			</APIAction>
			{externalLinks}
			
		</>
	)
}

function MyTicket({config: {display_scan_status, qr_code_informations}}) {
	const { t } = useTranslation();
	const { barcode, scan_date } = qr_code_informations;

	return (
		<div className='wz-neo-myticket-container'>
			<div className='wz-neo-myticket-title'>{t('widget.ticket.my-ticket')}</div>
			<div className='wz-neo-myticket-qrcode'>
				<QRCode value={barcode} size={185} />
				{
					display_scan_status &&
					<Chip 
						color={scan_date ? 'green' : 'gray'}
						icon={scan_date ? <Check className='wz-check-icon'/> : <Cross/>} 
						text={scan_date ? t('widget.ticket.scanned', {date: moment(scan_date).format('DD/MM/YYYY HH:mm')}) : t('widget.ticket.not-scanned')}
					/>
				}
			</div>
		</div>
	)
}

export function TicketMenu({ config, onSubmit }) {
	const { t } = useTranslation();

	const ticket_menu = config['ticket-menu'];

	const { header, actions } = ticket_menu;

	const _onSubmit = () => {
		return onSubmit({
			data: {
				action: 'OrderMenuStep',
			}
		}
	)}

	const { first_name, last_name, rate_name } = header;
	const title = `${first_name} ${last_name.toUpperCase()} - ${rate_name}`;
	const filteredActions = actions.filter(action => action.type !== 'OrderMenuStep');
	return (
		<Box>
			<div className='wz-neo-ticket-menu-back'>
				<BackContainer title={title} onClick={_onSubmit}/>
			</div>
			<Header data={header}/>
			{ticket_menu.config?.display_qr_code && <MyTicket config={ticket_menu['config']} />}
			<div className="wz-neo-ticket-action-text">{t('widget.ticket.action')}</div>
			{!filteredActions.length ?
				<Message type='info' title={t('widget.ticket.message-title')} description={t('widget.ticket.message-description')}/>
				:
				<TicketActions
					ticket={header}
					actions={actions}
					onActionClick={(action, payload) => {
						onSubmit({
							data: {
								action,
								payload
							}
						})
					}}
				/>
			}
		</Box>
	);
}
